import { useTypedParams } from '@sorare/routing';

import { Position } from '@sorare/core/src/__generated__/globalTypes';

import { RequestLineupForm } from '@sorare/gameplay/src/components/noCardRoute/RequestLineupForm';
import { disclaimerMessages } from '@sorare/gameplay/src/lib/noCardRoute';

import { PageParams } from './__generated__/routeParams';

const slotRounds = [[0], [1], [2], [3], [4]];
const lineups = [
  {
    positions: [
      Position.basketball_guard,
      Position.basketball_forward,
      Position.basketball_center,
    ],
    label: 'First',
  },
  {
    positions: [
      Position.basketball_guard,
      Position.basketball_forward,
      Position.basketball_center,
    ],
    label: 'Second',
  },
  {
    positions: [
      Position.basketball_guard,
      Position.basketball_forward,
      Position.basketball_center,
    ],
    label: 'Third',
  },
  {
    positions: [
      Position.basketball_guard,
      Position.basketball_forward,
      Position.basketball_center,
    ],
    label: 'Fourth',
  },
  {
    positions: [
      Position.basketball_guard,
      Position.basketball_forward,
      Position.basketball_center,
    ],
    label: 'Fifth',
  },
];

const NoCardEntry = () => {
  const { so5FixtureId } = useTypedParams<PageParams>();

  return (
    <RequestLineupForm
      so5FixtureId={so5FixtureId}
      slotRounds={slotRounds}
      lineup={lineups}
      disclaimers={[disclaimerMessages.leaderboardSelection]}
    />
  );
};

export default NoCardEntry;
